import { render, staticRenderFns } from "./RealmLesson.vue?vue&type=template&id=a293ca26"
import script from "./RealmLesson.vue?vue&type=script&lang=js"
export * from "./RealmLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports